import React, { useState } from 'react';
import cx from 'clsx';
import classes from './Disclaimer.module.scss';

const DISCLAIMER_TEXT =
  'The iTero Lumina PC-configuration intraoral scanners are available with different software packages and different capabilities depending on regulatory and commercial considerations.';

function InfoIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  );
}

interface DisclaimerProps {
  className?: string;
}

export default function Disclaimer({ className }: DisclaimerProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className={cx(classes.disclaimer, className)}>
      <button type="button" className={classes.trigger} onClick={() => setOpen(true)}>
        <InfoIcon className={classes.triggerIcon} />
        Disclaimer
      </button>

      {open && (
        <div
          className={classes.overlay}
          role="dialog"
          aria-modal="true"
          aria-labelledby="disclaimer-title"
          onClick={() => setOpen(false)}
        >
          <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
            <div className={classes.header}>
              <span className={classes.headerTitle}>
                <InfoIcon className={classes.headerIcon} />
                <span id="disclaimer-title" className={classes.headerText}>
                  Disclaimer
                </span>
              </span>
              <button
                type="button"
                className={classes.close}
                aria-label="Close"
                onClick={() => setOpen(false)}
              >
                &times;
              </button>
            </div>
            <p className={classes.text}>{DISCLAIMER_TEXT}</p>
            <div className={classes.actions}>
              <button type="button" className={classes.closeButton} onClick={() => setOpen(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
